import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getErrorMessage, mustBeArray, requestHasError } from '../../utils/lib';
import { BASE_URL, EXPORTED_STATUS_ID } from '../../constants';
import RebatesRCTIInvoiceList from './RebatesRCTIInvoiceList';
import RebatesRCTIBasicDetail from './RebatesRCTIBasicDetail';
import {listRebatesRCTIStatus, deleteRebatesRCTI, updateRebatesRCTI, 
        getRebatesRCTIDetail, listRebatesRCTIInvoices} from '../../actions/rebatesRCTIActions';
import RCTIInvoicesTotal from './RCTIInvoicesTotal';
import { push } from '../../utils/navigation';
import { toastr } from 'react-redux-toastr';

const RebatesRCTIEdit = props => {
    const {dispatch, gst, listRebatesRCTIStatus, updateRebatesRCTI,
            deleteRebatesRCTI, getRebatesRCTIDetail } = props;
    const { id } = useParams();
    const [allSelected, setAllSelected] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rctiStatus, setRCTIStatus] = useState(undefined);
    const [rctiStatusList, setRCTIStatusList] = useState([]);
    const [currentRebateRCTI, setCurrentRebateRCTI] = useState([]);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    useEffect(() => {
        fetchStatusList();
        getRebateDetail();
    }, []);
    const handleRCTIStatusChange = value => {
        setRCTIStatus(value);
    };
    const fetchStatusList = () => {
        dispatch(listRebatesRCTIStatus()).then(x => {
            setRCTIStatusList(mustBeArray(x && x.data));
        });
    };

    const getRebateDetail = () => {
        dispatch(getRebatesRCTIDetail({id})).then(resp => {
            if (!requestHasError({x: resp})) {
                if(resp.data && resp.data.exportStatusID === EXPORTED_STATUS_ID){
                    return dispatch(push(`${BASE_URL}/rebatesRCTI/${id}`));
                }
                setCurrentRebateRCTI(resp.data);
                setRCTIStatus(resp.data && resp.data.exportStatusID);
                let selectedLocations = mustBeArray(resp.data && resp.data.rebateRctiLines).reduce((a,b) => {
                    return [...a, b.locationID];
                },[]);
                setSelectedRows(selectedLocations);
              } 
        });
    };
    const handleCheckboxSelection = row => {
        let updatedSelectedRows = [];
        if(selectedRows.includes(row.locationID)){
            updatedSelectedRows = selectedRows.filter((a) => a !== row.locationID);
            setAllSelected(false);
        }
        else{
            updatedSelectedRows = [...selectedRows, row.locationID];
            if(updatedSelectedRows.length === mustBeArray(currentRebateRCTI.rebateRctiLines).length){
                setAllSelected(true);
            }
        }
        return setSelectedRows(updatedSelectedRows);
        
    };
    const handleAllSelected = () => {
        if(allSelected){
            setSelectedRows([]);
            setAllSelected(false);
        }
        else{
            let newSelectedRows = mustBeArray(currentRebateRCTI.rebateRctiLines).reduce((a,b) => {
                return [...a,b.locationID];
            },[]);
            setSelectedRows(newSelectedRows);
            setAllSelected(true);
        }
    };

    const getSubTotal = () => {
        let selectedRebates = mustBeArray(currentRebateRCTI.rebateRctiLines).filter(o => selectedRows.includes(o.locationID));
        let subTotalAmount = selectedRebates.reduce((a,b) => {
            return a+b.totalAmount;
        },0);
        return subTotalAmount;
    };

    const handleSave = () => {
        if(_.isEmpty(selectedRows)){
            return toastr.error("Saving Error: Client location is required.");
        }
        setSaveLoading(true);
        let selectedRebates = mustBeArray(currentRebateRCTI.rebateRctiLines).filter(o => selectedRows.includes(o.locationID));
        let totalRebateAmountExcGst = Number([...selectedRebates].reduce((a,b) => {
            return(a+b.totalAmount);
        },0)).toFixed(2);
        let gstAmount = Number((totalRebateAmountExcGst/gst).toFixed(2));
        let totalRebateAmount = (Number(totalRebateAmountExcGst) + Number(gstAmount)).toFixed(2);
        let payLoad = {
            id: currentRebateRCTI && currentRebateRCTI.id,
            rctiDate: currentRebateRCTI && currentRebateRCTI.rctiDate,
            clientID: currentRebateRCTI && currentRebateRCTI.clientID,
            exportStatusID: rctiStatus,
            totalRebateAmount,
            totalRebateAmountExcGst,
            gstAmount,
            rebateRctiLines: selectedRebates,
            rctiNumber: currentRebateRCTI && currentRebateRCTI.rctiNumber,
        };
        dispatch(updateRebatesRCTI({payLoad: [payLoad]})).then(x => {
            setSaveLoading(false);
            if(!requestHasError({x})){
                toastr.success("Rebates RCTI Updated.");
                dispatch(push(`${BASE_URL}/rebatesRCTI`));
            }
        });
    };

    const handleDelete = () => {
        setDeleteLoading(true);
        dispatch(deleteRebatesRCTI({id})).then(x => {
            setDeleteLoading(false);
            if (requestHasError({x})) {
                return(toastr.error(`Delete Error, error: ${getErrorMessage({x})}`));
              } 
              toastr.success("Rebates RCTI deleted.");
              dispatch(push(`${BASE_URL}/rebatesRCTI`));
        });
    };
    const handleCancel = () => {
        dispatch(push(`${BASE_URL}/rebatesRCTI`));
    };
    return(
        <React.Fragment>
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>Edit Rebates RCTI</h4>
                </div>
            </div>
            <RebatesRCTIBasicDetail 
                rctiDetails = {currentRebateRCTI}
                handleRCTIStatusChange = {handleRCTIStatusChange}
                rctiStatus = {rctiStatus}
                rctiStatusOptions = {rctiStatusList}
                editMode={true}
            />
            <RebatesRCTIInvoiceList 
                handleCheckboxSelection={handleCheckboxSelection}
                handleAllSelected={handleAllSelected}
                allSelected={allSelected}
                selectedRows={selectedRows}
                detailView={false}
                data={mustBeArray(currentRebateRCTI.rebateRctiLines)}
            />
            <div className="mt-2 full-width">
                <RCTIInvoicesTotal
                    subTotal = {getSubTotal()} 
                    gst = {gst} 
                />
            </div>
            <div className="mt-2 mb-2">
                <button className={`btn btn-primary ${saveLoading ? "no-pointer-events": ""}`} onClick={handleSave}>
                    <i className="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;{saveLoading ? "Saving": "Save RCTI"}
                </button>
                <button className="btn btn-default ml-1" onClick={handleCancel}>
                    <i className="fa fa-arrow-left" aria-hidden="true" ></i> &nbsp;Cancel
                </button>
                <button className={`btn btn-danger ml-1 bold float-right ${deleteLoading ? "no-pointer-events": ""}`} onClick={handleDelete}> 
                    <i className="fa fa-trash-o" aria-hidden="true"></i> &nbsp;{deleteLoading ? "Deleting": "Delete RCTI"}
                </button>
                <div className="clearfix"/>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps(state, ownProps){
  
    return {
      rctiDetails:  state.rebatesRCTI && state.rebatesRCTI.details, 
      gst: Number(state.apiConfig && state.apiConfig.gst)
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      listRebatesRCTIStatus,
      deleteRebatesRCTI,
      updateRebatesRCTI,
      listRebatesRCTIInvoices,
      getRebatesRCTIDetail
    };
  }

export default connect(mapStateToProps, mapDispatchToProps) (RebatesRCTIEdit);